import { jsx as _jsx } from "react/jsx-runtime";
import Link from "../../common/Link";
const DraggableButton = ({ item: { props, id }, ...rest }) => {
    const linkProps = {
        href: props?.link?.href,
        target: props?.link?.target,
        page: props?.link?.page,
        "editor-link-label": props?.link?.label,
        "editor-link-type": props?.link?.type,
        "editor-link-page": props?.link?.page,
    };
    return (_jsx(Link, { "editor-key": id, className: props?.className ||
            "font-text bg-site-600 hover:bg-site-500 focus-visible:outline-site-600 button rounded-md px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2", ...linkProps, ...rest, children: props?.link?.label || props?.text || "Button tekst" }));
};
export default DraggableButton;
//# sourceMappingURL=DraggableButton.js.map